import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import ReactTooltip from 'react-tooltip';
import { renderToStaticMarkup } from 'react-dom/server';

import {
	getNextIncompleteStep,
	getStepDefinitionByKey,
	goToSetupStep,
	isProfileSetupComplete
} from 'client/artist-ui/utils/next-setup-step';

import OnboardingProgress from './onboarding-progress';
import OnboardingSetupPanel from './onboarding-setup-panel';

@inject('userStore', 'artistStore')
@observer
class StatusIndicator extends Component {
	constructor (props) {
		super(props);
		this.state = {
			lockedStepKey: null,
			hoverStepKey: null
		};
	}

	componentDidUpdate () {
		const artist = this.props.artistStore.loggedInArtist;
		const { lockedStepKey } = this.state;

		if (!artist?.searchStatus || !lockedStepKey) {
			return;
		}

		if (artist.searchStatus[lockedStepKey]) {
			this.setState({ lockedStepKey: null });
		}
	}

	@autobind
	getPersistentStep (artist) {
		const { lockedStepKey } = this.state;
		const { searchStatus } = artist;

		if (lockedStepKey) {
			const def = getStepDefinitionByKey(lockedStepKey);

			if (def && !searchStatus[lockedStepKey]) {
				return def;
			}
		}

		return getNextIncompleteStep(searchStatus);
	}

	@autobind
	getDisplayStep (artist) {
		const { hoverStepKey } = this.state;
		const { searchStatus } = artist;

		if (hoverStepKey) {
			const hovered = getStepDefinitionByKey(hoverStepKey);

			if (hovered && !searchStatus[hoverStepKey]) {
				return hovered;
			}
		}

		return this.getPersistentStep(artist);
	}

	@autobind
	clearBundleHover () {
		this.setState({ hoverStepKey: null });
	}

	@autobind
	onStepPointerEnter (key) {
		const artist = this.props.artistStore.loggedInArtist;

		if (!artist?.searchStatus || artist.searchStatus[key]) {
			return;
		}

		this.setState({ hoverStepKey: key });
	}

	@autobind
	onStepActivate (key) {
		const artist = this.props.artistStore.loggedInArtist;

		if (!artist?.searchStatus || artist.searchStatus[key]) {
			return;
		}

		this.setState({ lockedStepKey: key, hoverStepKey: null });
	}

	render () {
		const { userStore, artistStore } = this.props;

		if (userStore.isLoading || artistStore.isLoading) {

			return (<h3>Status Indicator Loading...</h3>);
		}

		const artist = artistStore.loggedInArtist;
		const checkOnboarding = isProfileSetupComplete(artist.searchStatus);
		const nextStep = !checkOnboarding ? getNextIncompleteStep(artist.searchStatus) : null;
		const displayStep = !checkOnboarding ? this.getDisplayStep(artist) : null;
		const isPreview = Boolean(this.state.hoverStepKey) &&
			displayStep?.key === this.state.hoverStepKey;

		return (
			<div>
				{ !checkOnboarding &&
						(<div className="account-status account-status--with-next">
							<span className="account-status__label">Account Status:</span>
							<div className="inactive-status">
								<i className="far fa-minus-circle"/>
								<b
									style={ { textDecoration: 'dashed underline' } }
									data-html={ true }
									data-tip={ renderToStaticMarkup(this.renderArtistStatusList(artist)) }
								>Inactive</b>
							</div>
							{ nextStep ? (
								<span className="acms-status-next">
									Next:&nbsp;
									<button
										type="button"
										className="acms-status-next__btn"
										onClick={ () => goToSetupStep(nextStep) }
									>
										{ nextStep.shortLabel }
									</button>
								</span>
							) : null }
						</div>)
				}

				{ checkOnboarding && (
					<div className="account-status">Account Status: <i className="far fa-check-circle" style={ { color: '#00cc00' } }></i>
						<b>Active</b>
					</div>
				) }

				{ !checkOnboarding &&
					(<div>
						<div className="section-title artist heading margin-bottom-0">Artist Onboarding</div>
						<p className="acms-onboarding-intro">
							Complete these steps to activate your account.
						</p>
						<div
							className="acms-onboarding-bundle"
							onMouseLeave={ this.clearBundleHover }
						>
							<OnboardingProgress
								artist={ artist }
								onStepPointerEnter={ this.onStepPointerEnter }
								onStepActivate={ this.onStepActivate }
							/>
							<OnboardingSetupPanel step={ displayStep } isPreview={ isPreview } />
						</div>
					</div>)
				}
				<ReactTooltip html place="bottom" effect="solid" />
			</div>
		);
	}

	renderArtistStatusList (artist) {
		const { hasBannerImage, hasBio, hasEnoughSongs, hasProfileImage, hasStripeSetup } = artist.searchStatus;

		return (
			<div>
				<ul style={ { listStyleType: 'none' } }>
					<li style={ hasProfileImage ? { color: '#00cc00', display: 'flex' } : { color: '#cc0000' } }>
						<i className={ hasProfileImage ? 'far fa-check-circle' : 'far fa-minus-circle' }/>Profile image
					</li>
					<li style={ hasBannerImage ? { color: '#00cc00' } : { color: '#cc0000' } }>
						<i className={ hasBannerImage ? 'far fa-check-circle' : 'far fa-minus-circle' }/>Banner image
					</li>
					<li style={ hasBio ? { color: '#00cc00' } : { color: '#cc0000' } }>
						<i className={ hasBio ? 'far fa-check-circle' : 'far fa-minus-circle' }/>Bio
					</li>
					<li style={ hasEnoughSongs ? { color: '#00cc00' } : { color: '#cc0000' } }>
						<i className={ hasEnoughSongs ? 'far fa-check-circle' : 'far fa-minus-circle' }/>At least 1 song
					</li>
					<li style={ hasStripeSetup ? { color: '#00cc00' } : { color: '#cc0000' } }>
						<i className={ hasStripeSetup ? 'far fa-check-circle' : 'far fa-minus-circle' }/>Stripe setup
					</li>
				</ul>
			</div>
		);
	}
}

export default StatusIndicator;
